import React, { useState, useEffect } from "react";

import {
  Container,
  Row,
  Col,
  Card,
  Form,
  ButtonGroup,
  Button,
  Modal,
} from "react-bootstrap";

import PageTitle from "../components/common/PageTitle";
import api from "../../src/api/api";
import { useTranslation } from "react-i18next";
import Pagination from "../views/Pagination";

import swal from "sweetalert";
import { LinearProgress } from "@mui/material";
import { useNavigate } from "react-router";
import "./AdminManagement.css";

const formatTunisiaDateTime = (value, locale = "fr-FR") => {
  if (!value) return "-";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "-";
  const localeMap = {
    ar: "ar-TN",
    en: "en-GB",
    fr: "fr-FR",
    it: "it-IT",
    wf: "fr-FR",
  };
  return new Intl.DateTimeFormat(localeMap[locale] || "fr-FR", {
    timeZone: "Africa/Tunis",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  }).format(date);
};

const SensorsManagement = () => {
  const navigate = useNavigate();

  const [toggle, setToggle] = useState(false);

  const [sensorsPerPage, setSensorPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [SearchCode, setSearchCode] = useState("");
  const [selectedUser, setSelectedUser] = useState("");
  const [selectedSupplier, setSelectedSupplier] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [code, setCode] = useState("");

  const [userUid, setUserUid] = useState("");
  const [users, setUsers] = useState([]);

  const [allSensors, setAllSensors] = useState([]);

  const [existUsers, setExistUsers] = useState([]);

  const [existSuppliers, setExistSuppliers] = useState([]);
  const [supplierUid, setSupplierUid] = useState("");

  const [supplier, setSupplier] = useState(false);
  const { t, i18n } = useTranslation();

  const sendNotificationEmail = async (userEmail, sensorState, sensorInfo) => {
    try {
      await api.post("/admin/send-notification-email", {
        userEmail,
        sensorState,
        sensorInfo,
      });
    } catch (error) {
      console.error("Error sending email notification:", error);
    }
  };

  useEffect(() => {
    if (users.length > 0) {
      const checkSensor = async () => {
        try {
          const response = await api.get("/admin/check-sensor-status");
          const inactiveSensors = response.data.inactiveSensors;
          inactiveSensors.forEach((inactiveSensor) => {
            const sensorCode = inactiveSensor.sensor.code;
            let ownerName = "";
            let supplierName = ""; // You need to retrieve the owner name based on user_id
            const lastDataTime = inactiveSensor.connectivityStatus?.lastReceivedAt
              ? new Date(inactiveSensor.connectivityStatus.lastReceivedAt)
              : null;

            // Additional information from the inactiveSensor object if needed
            const sensorId = inactiveSensor.sensor.id;
            const supplierId = inactiveSensor.sensor.supplier_id;
            users.map((user) => {
              if (user.id === inactiveSensor.sensor.user_id) {
                ownerName = user.name;
              }
            });
            existSuppliers.map((user) => {
              if (user.id === inactiveSensor.sensor.supplier_id) {
                supplierName = user.name;
              }
            });
            sendNotificationEmail("contact@smartfarm.com.tn", "Inactive", {
              sensorCode,
              ownerName,
              lastDataTime,
              supplierName,
            });
          });
        } catch (error) {
          console.error(error);
        }
      };

      const statusCheckInterval = setInterval(() => {
        checkSensor();
      }, 5 * 60 * 1000); // 5 minutes

      return () => clearInterval(statusCheckInterval);
    }
  }, [users, existSuppliers]);

  const getAllSensors = async () => {
    await api
      .get("/admin/all-sensors")
      .then((response) => {
        setAllSensors(Array.isArray(response.data.sensors) ? response.data.sensors : []);
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => setIsLoading(false));
  };

  const getExistUsers = async () => {
    await api
      .get("/admin/users")
      .then((response) => {
        var Data = response.data.users;
        setExistUsers(Data);
        setSupplier(false);
        setSupplierUid("");
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const getExistSuppliers = async () => {
    await api
      .get("/admin/exist-suppliers")
      .then((response) => {
        var Data = response.data.suppliers;
        setExistSuppliers(Data);
        setSupplierUid(Data.uid);
        setSupplier(true);
        setUserUid("");
      })
      .catch((err) => {
        console.error(err);
      });
  };
  const getUsersList = async () => {
    let data = await api.get("/admin/users").then((response) => {
      let usersData = response.data.users;
      setUsers(usersData);
    });
  };

  useEffect(() => {
    getAllSensors();
    getUsersList();
    getExistUsers();
    getExistSuppliers();
    const statusRefreshInterval = setInterval(getAllSensors, 120000);
    return () => clearInterval(statusRefreshInterval);
  }, []);

  useEffect(() => {
    setCurrentPage(1);
  }, [SearchCode, selectedUser, selectedSupplier, sensorsPerPage]);

  const filteredSensors = allSensors.filter((sensor) => {
    const searchTerm = SearchCode.trim().toLowerCase();
    const matchesCode =
      searchTerm === "" ||
      String(sensor.sensor?.code || "").toLowerCase().includes(searchTerm);
    const matchesUser =
      selectedUser === "" || sensor.sensor.user_id == selectedUser;
    const matchesSupplier =
      selectedSupplier === "" || sensor.sensor.supplier_id == selectedSupplier;
    return matchesCode && matchesUser && matchesSupplier;
  });

  // Pagination

  const indexOfLastPost = currentPage * sensorsPerPage;
  const indexOfFirstPost = indexOfLastPost - sensorsPerPage;
  const currentSensors = filteredSensors.slice(
    indexOfFirstPost,
    indexOfLastPost
  );

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const assignSensorToUser = (userUid, supplierUid) => {
    let data = {
      code: code,
      user_uid: userUid,
      supplier_uid: supplierUid,
    };
    api
      .post("/admin/edit-sensor", data)
      .then((response) => {
        if (response.data.type === "success") {
          swal(`${t("sensor_updated")}`, {
            icon: "success",
          });
          setToggle(false);
          getAllSensors();
        }
        if (response.data.type === "danger") {
          swal({
            icon: "error",
            title: t("Oops..."),
            text: t("Error"),
          });
        }
      })
      .catch((err) => {
        swal({
          icon: "error",
          title: t("Oops..."),
          text: t("Error"),
        });
      });
  };

  const getSingleSensor = async (sensorid, type) => {
    await api
      .get(`/admin/single-sensor/${sensorid}`,{timeout:0})
      .then((res) => {
        let sensorData = res.data.sensor;
        setCode(sensorData.code);
        existUsers.map((user) => {
          if (user.id === sensorData.user_id) {
            setUserUid(user.uid);
          }
        });
        existSuppliers.map((supplier) => {
          if (supplier.id === sensorData.supplier_id) {
            setSupplierUid(supplier.uid);
          }
        });
      })
      .catch((error) => {
        swal({
          title: t("Error"),
          icon: "error",
        });
      });
    setToggle(!toggle);
    if (type === "User") {
      getExistUsers();
    }
    if (type === "Supplier") {
      getExistSuppliers();
    }
  };

  const resetForm = () => {
    setTimeout(() => {
      setUserUid("");
      setSupplierUid("");
    }, 1000);
  };

  const handleCalculSensor = () => {
    api
      .post("/calcul/add-sensor-calcul")
      .then((response) => {
        if (response.data.type === "success") {
          swal(`${t("calcul_added")}`, {
            icon: "success",
          });
        }
        if (response.data.type === "danger") {
          swal({
            icon: "error",
            title: t("Oops..."),
          });
        }
      })
      .catch((err) => {
        swal({
          icon: "error",
          title: t("Oops..."),
        });
      });
  };

  const handleDelete = async (sensorUid) => {
    let data = {
      sensor_uid: sensorUid,
    };
    await api
      .delete("/sensor/delete-sensor", { data: data })
      .then((response) => {
        if (response.data.type && response.data.type == "danger") {
          swal({
            title: t("cannot_delete_sensor"),
            icon: "warning",
          });
        }
        if (response.data.type == "success") {
          getAllSensors();
        }
      })
      .catch((error) => {
        console.error(error);
        swal({
          title: t("cannot_delete_sensor"),
          icon: "error",
          text: t("Error"),
        });
      });
  };

  const confirmDelete = (sensorUid) => {
    swal({
      title: t("Are you sure?"),
      text: t("confirm_delete_sensor"),
      icon: "warning",
      buttons: true,
      dangerMode: true,
    })
      .then((Delete) => {
        if (Delete) {
          handleDelete(sensorUid);
          swal(t("sensor_deleted"), {
            icon: "success",
          });
        }
      })
      .catch((error) => {
        console.error(error);
        swal({
          title: t("cannot_delete_sensor"),
          icon: "error",
          text: t("Error"),
        });
      });
  };
  const fetchDataSensor = async (sensorUid, code) => {
    try {
      await api
        .post("/sensor/activate-synch", { sensor_uid: sensorUid })
        .then((response) => {
          if (response.data.type === "success") {
            swal(`${t("sensor_updated")}`, {
              icon: "success",
            });
            getAllSensors();
          }
          if (response.data.type === "danger") {
            swal({
              icon: "error",
              text: t("Error"),
            });
          }
        })
        .catch((err) => {
          swal({
            icon: "error",
            text: t("Error"),
          });
        });
    } catch (error) {
      swal({
        icon: "error",
        text: t("Error"),
      });
    }
  };

  const handleSensorsPerPageChange = (event) =>
    setSensorPerPage(Number(event.target.value));
  return (
    <>
      <Container className="admin-management-page">
        <Row noGutters className="page-header admin-management-heading">
          <PageTitle
            sm="4"
            title={t("list_sensors")}
            subtitle={t("list_sensors")}
            className="text-sm-left"
          />
        </Row>
        <section className="admin-management-toolbar">
          <div className="admin-management-toolbar-title">
            <i className="fas fa-filter" aria-hidden="true" />
            {t("search_sensors")}
          </div>
        <Row form className="admin-management-filters">
          <Col className="form-group">
            <Form.Group>
              <div className="d-flex">
                <Form.Control
                  value={SearchCode}
                  onChange={(e) => setSearchCode(e.target.value)}
                  id="search"
                  placeholder= {t('search_by_code')}
                />
              </div>
            </Form.Group>
          </Col>
          <Col className="form-group">
            <Form.Group>
              <div className="d-flex">
                <Form.Select
                  onChange={(e) => setSelectedUser(e.target.value)}
                  value={selectedUser}
                >
                  {selectedUser === "" ? (
                    <option value="">{t('Select by user')}</option>
                  ) : (
                    <option value="">{t("see_all")}</option>
                  )}

                  {existUsers
                    .sort((a, b) => a.name.localeCompare(b.name))
                    .map((user) => {
                      return <option key={user.id} value={user.id}>{user.name}</option>;
                    })}
                </Form.Select>
              </div>
            </Form.Group>
          </Col>
          <Col>
            <Form.Group>
              <div className="d-flex ">
                <Form.Select
                  onChange={(e) => setSelectedSupplier(e.target.value)}
                  value={selectedSupplier}
                >
                  {selectedSupplier === "" ? (
                    <option value="">{t('Select by supplier')}</option>
                  ) : (
                    <option value="">{t("see_all")}</option>
                  )}
                  {existSuppliers
                    .sort((a, b) => a.name.localeCompare(b.name))
                    .map((user) => {
                      return <option key={user.id} value={user.id}>{user.name}</option>;
                    })}
                </Form.Select>
              </div>
            </Form.Group>
          </Col>

          <Col className="admin-management-actions">
            <ButtonGroup className="gap-2">
              <Button
                variant="outline-primary"
                onClick={() => navigate("/admin/add-sensor")}
              >
                {t('Add Sensor')}
              </Button>
              <Button
                variant="outline-primary"
                onClick={() => handleCalculSensor()}
              >
                                {t('calcul')}

              </Button>
            </ButtonGroup>
          </Col>
        </Row>
        </section>
        <Row className="admin-pagination-row justify-content-center flex-column align-items-center">
          <div className="d-flex justify-content-center align-items-start">
            <label className="px-2" htmlFor="sensorsPerPage">
              {t('Sensors per page:')}
            </label>
            <select
              id="sensorsPerPage"
              value={sensorsPerPage}
              onChange={handleSensorsPerPageChange}
            >
              <option value="10">10</option>
              <option value="20">20</option>
            </select>
          </div>
          <Pagination
            usersPerPage={sensorsPerPage}
            totalUsers={filteredSensors.length}
            paginate={paginate}
            currentPage={currentPage}
          />
        </Row>
        <Card className="admin-data-card">
          {isLoading ? (
            <LinearProgress />
          ) : (
            <table className="table mb-0 text-center table-hover table-responsive-lg">
              <thead className="bg-light">
                <tr>
                  <th scope="col" className="border-0">
                    {t("sensor_code")}
                  </th>
                  <th scope="col" className="border-0">
                    {t("sensor_firmware_version")}
                  </th>
                  <th scope="col" className="border-0">
                    {t("user")}
                  </th>
                  <th scope="col" className="border-0">
                    {t("supplier")}
                  </th>
                  <th scope="col" className="border-0">
                    {t("last_reading")}
                  </th>
                  <th scope="col" className="border-0">
                    {t("expected")}
                  </th>
                  <th scope="col" className="border-0">
                    {t("statu")}
                  </th>
                  <th scope="col" className="border-0">
                    {t("actions")}
                  </th>
                  <th scope="col" className="border-0"></th>
                </tr>
              </thead>
              <tbody>
                {currentSensors.length === 0 && (
                  <tr>
                    <td colSpan="9" className="admin-empty-row">{t("no_data_available")}</td>
                  </tr>
                )}
                {currentSensors.map((sensor, index) => {
                  let nameUser = "-";
                  let nameSupplier = "-";
                  users.map((user) => {
                    if (user.id === sensor.sensor.user_id) {
                      nameUser = user.name;
                    }
                  });
                  existSuppliers.map((user) => {
                    if (user.id === sensor.sensor.supplier_id) {
                      nameSupplier = user.name;
                    }
                  });
                  const connectivityStatus = sensor.connectivityStatus || {};
                  const lastDataTime = formatTunisiaDateTime(
                    connectivityStatus.lastReceivedAt,
                    i18n.language,
                  );
                  const formattedTime = formatTunisiaDateTime(
                    connectivityStatus.offlineAt,
                    i18n.language,
                  );
                  const sensorState = connectivityStatus.state || "unavailable";
                  const storedFirmwareVersion = String(sensor.sensor.firmware_version || "");
                  const firmwareVersion = ["1", "2"].includes(storedFirmwareVersion)
                    ? storedFirmwareVersion
                    : sensor.sensor.firmware_profile === "buffered_batch_v2" ? "2" : "1";
                  const sensorStateLabel = sensorState === "online"
                    ? t("online")
                    : sensorState === "low_battery"
                      ? t("low_batt")
                      : sensorState === "offline"
                        ? t("offline")
                        : t("sensor_data_unavailable_short", {
                            defaultValue: "Données indisponibles",
                          });

                  return (
                    <tr key={index}>
                      <td style={{ fontSize: 11.5, fontWeight: "bold" }}>
                        {sensor.sensor.code}
                      </td>
                      <td>
                        <span className={`sensor-firmware-badge is-v${firmwareVersion}`}>
                          <i className="fas fa-microchip" aria-hidden="true" />
                          {t(`sensor_firmware_v${firmwareVersion}_short`, {
                            defaultValue: `V${firmwareVersion}`,
                          })}
                        </span>
                      </td>
                      <td style={{ fontSize: 11.5, fontWeight: "bold" }}>
                        {nameUser}
                      </td>
                      <td style={{ fontSize: 11.5, fontWeight: "bold" }}>
                        {nameSupplier}
                      </td>
                      <td style={{ fontSize: 11.5, fontWeight: "bold" }}>
                        {lastDataTime}
                      </td>
                      <td style={{ fontSize: 11.5, fontWeight: "bold" }}>
                        {formattedTime}
                      </td>
                      <td>
                        <span className={`admin-status ${
                          sensorState === "online"
                            ? "is-active"
                            : sensorState === "offline"
                              ? "is-inactive"
                              : sensorState === "low_battery"
                                ? "is-battery"
                                : "is-unknown"
                        }`}>
                          {sensorStateLabel}
                        </span>
                      </td>
                      <td>
                        {sensor.sensor.deleted_at === null ? (
                          <ButtonGroup size="sm" className="mr-2">
                            <Button
                              title={t("edit")}
                              aria-label={t("edit")}
                              variant="primary"
                              onClick={() => {
                                navigate(
                                  `/admin/edit-sensor/${sensor.sensor.id}`,
                                  {
                                    state: {
                                      lastDataTime,
                                      formattedTime,
                                      sensorState,
                                    },
                                  }
                                );
                              }}
                            >
                              <i className="material-icons" aria-hidden="true">&#xe3c9;</i>
                            </Button>
                            <Button
                              title={t("history")}
                              aria-label={t("history")}
                              variant="info"
                              onClick={() => {
                                navigate(`/my-history/${sensor.sensor.code}`);
                              }}
                            >
                              <i className="material-icons" aria-hidden="true">&#xe889;</i>
                            </Button>
                            <Button
                              title={t("delete")}
                              aria-label={t("delete")}
                              variant="danger"
                              onClick={() => {
                                confirmDelete(sensor.sensor.uid);
                              }}
                            >
                              <i className="material-icons" aria-hidden="true">&#xe872;</i>
                            </Button>
                            {sensor.sensor.synchronized === "0" ? (
                              <Button
                                title={t("synchronize")}
                                aria-label={t("synchronize")}
                                variant="info"
                                onClick={() =>
                                  fetchDataSensor(
                                    sensor.sensor.uid,
                                    sensor.sensor.code
                                  )
                                }
                              >
                                <i className="material-icons" aria-hidden="true">&#xe627;</i>
                              </Button>
                            ) : null}
                          </ButtonGroup>
                        ) : null}
                      </td>
                      <td>
                        {sensor.sensor.deleted_at === null ? (
                          <ButtonGroup size="sm" className="mr-2">
                            <Button
                              variant="outline-primary"
                              onClick={() =>
                                getSingleSensor(sensor.sensor.id, "User")
                              }
                            >
                              {t('Assign to user')}
                            </Button>
                            <Button
                              variant="outline-primary"
                              onClick={() =>
                                getSingleSensor(sensor.sensor.id, "Supplier")
                              }
                            >
                              {t('Assign to supplier')}
                            </Button>
                          </ButtonGroup>
                        ) : null}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          )}
        </Card>
      </Container>
      <Modal centered={true} show={toggle} onHide={() => setToggle(false)} dialogClassName="admin-management-modal">
        <Modal.Header closeButton>
          <Modal.Title>{t("sensor_code")} {code}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row className="d-flex justify-content-center">
            <Col lg="9" md="10" sm="12">
              <Form.Group>
                <label htmlFor="users">{t("Select_user_assign_sensor")}</label>
                {supplier === true ? (
                  <Form.Select
                    id="users"
                    value={supplierUid}
                    onChange={(e) => setSupplierUid(e.target.value)}
                  >
                    <option value="">{t("Select_Supplier")}</option>

                    {existSuppliers.map((supplier) => {
                      return (
                        <option key={supplier.uid} value={supplier.uid}>{supplier.name}</option>
                      );
                    })}
                  </Form.Select>
                ) : (
                  <Form.Select
                    id="users"
                    value={userUid}
                    onChange={(e) => {
                      setUserUid(e.target.value);
                    }}
                  >
                    <option value="">{t("select_user", { defaultValue: "Select User" })}</option>

                    {existUsers.map((user) => {
                      return <option key={user.uid} value={user.uid}>{user.name}</option>;
                    })}
                  </Form.Select>
                )}
              </Form.Group>
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="outline-secondary"
            onClick={() => {
              resetForm();
              setToggle(false);
            }}
          >
            <i className="fa fa-times mr-2" aria-hidden="true" />
            {t("cancel")}
          </Button>
          <Button onClick={() => assignSensorToUser(userUid, supplierUid)}>
            <i className="fa fa-check mr-2" aria-hidden="true" />
            {t("save")}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default SensorsManagement;
